import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { IDeleteDataResponseAndPayload, TResponse, TResponseWithQData } from "../../../types/common";
import { ISubAdminPayload } from "../../../types/api/subAdmin";


export async function listSubAdmins(
  qData: QData
): Promise<AxiosResponse<TResponseWithQData<ISubAdminPayload[]>>> {
  return axios.get(API_ENDPOINTS.SUB_ADMIN_LIST, {
    params: qData,
  });
}

export async function createSubAdmins(
  payload: ISubAdminPayload
): Promise<AxiosResponse<TResponse<ISubAdminPayload>>> {
  return axios.post(API_ENDPOINTS.SUB_ADMIN_SAVE, payload);
}

export async function subAdminDetails(id:string): Promise<AxiosResponse<TResponse<ISubAdminPayload>>> {
    return axios.get(`${API_ENDPOINTS.SUB_ADMIN_DETAILS}/${id}`)
}


export async function deleteSubAdmin(data: IDeleteDataResponseAndPayload): Promise<AxiosResponse<TResponse<IDeleteDataResponseAndPayload>>> {
    return axios.post<TResponse<IDeleteDataResponseAndPayload>>(API_ENDPOINTS.SUB_ADMIN_DELETE, data)
}
